import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import { PAGINATION_DEFAULTS } from '../../../utils/constants';

/**
 * Pagination Component
 */
const Pagination = ({
  currentPage,
  totalPages,
  rowsPerPage,
  totalItems,
  startIndex,
  onPageChange,
  onRowsPerPageChange
}) => {
  const { colors } = useTheme();

  return (
    <div className={`px-4 md:px-6 py-4 ${colors.tableHeader} border-t ${colors.tableBorder} flex-shrink-0`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center space-x-2 md:space-x-4">
          <span className={`text-xs md:text-sm ${colors.paginationText}`}>Rows per page:</span>
          <select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            className={`${colors.borderSecondary} rounded-xl px-2 md:px-3 py-1 md:py-1.5 text-xs md:text-sm ${colors.paginationBg} ${colors.inputText} shadow-sm focus:outline-none focus:ring-2 ${colors.inputFocus}`}
          >
            {PAGINATION_DEFAULTS.rowsPerPageOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <div className="flex items-center justify-between sm:justify-end space-x-4">
          <span className={`text-xs md:text-sm ${colors.paginationText}`}>
            {startIndex + 1}-{Math.min(startIndex + rowsPerPage, totalItems)} of {totalItems}
          </span>
          <div className={`flex space-x-2 ${colors.paginationBg} rounded-xl p-1 shadow-sm`}>
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`p-2 ${colors.textTertiary} ${colors.paginationHover} disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-all duration-200`}
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`p-2 ${colors.textTertiary} ${colors.paginationHover} disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-all duration-200`}
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
